import React, { useEffect, useState } from "react";
import axios from "axios";
import { pathSpliter } from "../../lib/functions";
import { emailValidateApi, emailApproveApi,getAttendanceEmployeeApi } from "../../apiservice/hrpayroll";
import { BACKEND_API_URL } from "../../environment";
import { useParams, useNavigate } from "react-router-dom";

const ClientApproveAttendance = ({ location, currentRouteSet, currentRoute }) => {
  const [validationStatus, setValidationStatus] = useState("loading");
  const [message, setMessage] = useState("");
//   const [token, setToken] = useState("");
  const [comment, setComment] = useState("");
  const [isDisable, setIsDisable] = useState(false);
     const { token } = useParams();
  useEffect(() => {
    // const path =
    //   pathSpliter(location.pathname, 2) != undefined
    //     ? pathSpliter(location.pathname, 2)
    //     : 0;

    // setToken(path);
    const validateToken = async () => {
    

      if (!token) {
        setValidationStatus("error");
        setMessage("No token provided.");
        return;
      }
      const payLoad = {
        token: token,
      };

      try {
        const response = await axios.post(
          `${BACKEND_API_URL}/validate-token`,
          payLoad
        );
        

        if (response.status === 200) {
          setValidationStatus("valid");
          setMessage("Token is valid. Proceeding with the action...");
          // await performActionWithToken(token);
        } else {
          setValidationStatus("error");
          setMessage("Invalid or expired token.");
        }
      } catch (error) {
        console.error("Error validating token:", error);
        setValidationStatus("error");
        setMessage(
          error.response?.data?.message ||
            "An error occurred while validating the token."
        );
      }
    };

    validateToken();
  }, [token]);




  const onChangeAttendanceStatus = async (value) => {
    try {
      const payload = {
        token: token,
        status: value,
        comment: comment,
      };
      const response = await axios.post(
        `${BACKEND_API_URL}/approve-attendance`,
        payload
      );

      if (response.status === 200) {
        setMessage(response.data.message);
        setIsDisable(true)
      } else {
        setMessage("Failed to complete the action.");
      }
    } catch (error) {
      console.error("Error performing action with token:", error);
      setMessage("Error performing the action.");
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "40px" }}>
      <h1 style={{ marginBottom: "20px" }}>Approve Attendance</h1>

      {validationStatus === "loading" && <p>Loading...</p>}

      {validationStatus === "valid" && (
        <div>
          <div style={{ marginBottom: "20px" }}>
            <textarea
              placeholder="Add your comment here"
              onChange={(e) => {
                setComment(e.target.value);
              }}
              style={{
                width: "80%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "20px",
                minHeight: "100px",
              }}
            />
          </div>

          <div>
            <button
              onClick={() => onChangeAttendanceStatus(true)}
              disabled={isDisable}
              style={{
                backgroundColor: "green",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                fontSize: "16px",
                margin: "0 10px",
                cursor: "pointer",
              }}
            >
              Approve
            </button>
            <button
              onClick={() => onChangeAttendanceStatus(false)}
              disabled={isDisable}
              style={{
                backgroundColor: "red",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                fontSize: "16px",
                margin: "0 10px",
                cursor: "pointer",
              }}
            >
              Reject
            </button>
          </div>

          <p>{message}</p>
        </div>
      )}

      {validationStatus === "error" && (
        <div>
          <h1 style={{ marginBottom: "20px" }}>Error</h1>
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

export default ClientApproveAttendance;
